/* 
As a user, I want to get a great first impression when I first open Love Big's website
So that I can know quickly if I want to utilize Love Big as an option for
managing my organization.
*/

//Packages
import React, { useContext, useEffect } from "react";
import { Link } from "react-router-dom";
import smoothscroll from "smoothscroll-polyfill";
//Material UI Components
import { Grid, Typography, Box, Stack, Button } from "@mui/material";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import { makeStyles, useTheme } from "@mui/styles";
//Animation
import { motion } from "framer-motion";
//Assets
import homeStock1 from "../../assets/images/homeStock1.png";
import homeStock2 from "../../assets/images/homeStock2.png";
import homeStock3 from "../../assets/images/homeStock3.png";
import worldMapDot from "../../assets/images/worldmapdot.png";
import scrollDown from "../../assets/images/scroll-down.svg";
import homeStock2mobile from "../../assets/images/homeStock2mobile.png";
import RightArrow from "../../assets/images/arrow1.png";
import { userContext } from "../../Context";
smoothscroll.polyfill();
//Material UI Styles
const useStyles = makeStyles({
  button: {
    fontFamily: '"Roboto", sans-serif',
    textDecoration: "none",
    fontSize: "14px",
    color: "#ffffff",
    padding: "6.5px 12.5px 6.5px 12.5px",
    borderRadius: "16px",
    backgroundColor: "#052442",
    width: "fit-content",
  },
  arrowDown: {
    fontSize: "40px",
  },
  imageContainer: {
    display: "flex",
    alignItems: "center",
  },
  image1: {
    width: "75%",
    float: "right",
  },
  image2: {
    position: "absolute",
    top: "70px",
    width: "50%",
  },
  image2mobile: {
    objectFit: "cover",
    objectPosition: "45% 0",
    height: "100%",
    width: "100%",
    overflowX: "hidden",
  },
  bottomDiv: {
    backgroundImage: `url(${worldMapDot})`,
  },
  blueBox: {
    backgroundColor: "#339CD5",
    color: "#ffffff",
    position: "relative",
    borderRadius: "30px",
  },
  blueBoxBkg: {
    position: "absolute",
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    width: "100%",
    height: "100%",
    background: `url(${homeStock3})`,
    mixBlendMode: "multiply",
    zIndex: 0,
    borderRadius: "inherit",
  },
  blueBoxContent: {
    position: "relative",
    zIndex: 1,
  },
  link: {
    textDecoration: "none",
  },
  scrollDownButton: {
    position: "absolute",
    bottom: 50,
    left: "calc(50% - 40px)",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "flex-start",
    fontSize: 12,
    cursor: "pointer",
    zIndex: 1,
  },
  scrollDownButtonText: {
    color: "#104D82",
    textAlign: "center",
    textTransform: "uppercase",
  },
  scrollDownIcon: {
    animation: `$bounce 2s infinite`,
  },
  "@keyframes bounce": {
    "0%, 20%, 50%, 80%, 100%": {
      transform: "translateY(0)",
    },
    "40%": {
      transform: "translateY(-30px)",
    },
    "60%": {
      transform: "translateY(-15px)",
    },
  },
  blueBoxContentWrapper: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    marginBottom: 40,
    "& img": {
      marginRight: 40,
      ["@media screen and (max-width: 767px)"]: {
        marginRight: 20,
      },
    },
  },
  blueBoxAction: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
  },
});
export default function Home() {
  const theme = useTheme();
  const { isAuthenticated } = useContext(userContext);
  const styles = useStyles(theme);
  const handleScrollDown = () => {
    const element =
      document.getElementById("humanitarian-collective").getBoundingClientRect()
        .top + window.scrollY;
    window.scroll({
      top: element,
      behavior: "smooth",
    });
  };
  const handleScrollDownToBottom = () => {
    const element =
      document.querySelector(".footer").getBoundingClientRect().top +
      window.scrollY;
    window.scroll({
      top: element,
      behavior: "smooth",
    });
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      <div className="home">
        <Grid
          container
          justifyContent={{ xs: "center", md: "space-between" }}
          alignItems="center"
        >
          <div
            className={styles.scrollDownButton}
            onClick={() => handleScrollDown()}
          >
            <div className={styles.scrollDownButtonText}>scroll down</div>
            <div className={styles.scrollDownIcon}>
              <img src={scrollDown} alt="" />
            </div>
          </div>
          <Grid
            item
            xs={7}
            sm={6}
            md={4}
            justifyContent="center"
            alignItems="center"
            ml={{ md: 12 }}
            mb={{ xs: 2 }}
            pt={{ xs: 2, sm: 4, lg: 0 }}
          >
            <Stack spacing={2}>
              <Typography variant="h4" fontWeight={100} color="#0060a4" mb={1}>
                A Nexus Connecting
              </Typography>
              <Typography
                fontSize={{ xs: "24px", sm: "30px", md: "40px" }}
                fontWeight={100}
              >
                Great humanitarian organizations with those in need
              </Typography>
              <Stack
                spacing={2}
                alignItems="center"
                display={{ xs: "none", md: "block" }}
              >
                <Grid container spacing={4} mt={3}>
                  {/* <Grid item>
                    <ArrowForwardIcon
                      style={{ fontSize: "30px" }}
                    ></ArrowForwardIcon>
                  </Grid> */}
                  <Grid item md={9}>
                    <Stack spacing={2}>
                      {/* <Typography variant="h6" fontWeight={400}>
                        Hope, Healing & Love
                      </Typography>
                      <Typography variant="body2" fontWeight={400}>
                        Join great hearts and mind to impact a world in need -
                        in an unprecedented way.
                      </Typography> */}
                      <Link to="/explore" className={styles.link}>
                        <Button color="primary" variant="contained">
                          Search Projects
                        </Button>
                      </Link>
                    </Stack>
                  </Grid>
                </Grid>
              </Stack>
            </Stack>
          </Grid>
          <Grid item md={6} display={{ md: "block", xs: "none" }}>
            <Box sx={{ position: "relative" }}>
              <img
                src={homeStock1}
                alt="Getting water"
                className={styles.image1}
              ></img>
              <img
                src={homeStock2}
                alt="Happy children smiling"
                className={styles.image2}
              ></img>
            </Box>
          </Grid>
        </Grid>

        <Box
          display={{ md: "none", xs: "block" }}
          height="300px"
          width="100%"
          className={styles.imageContainerMobile}
        >
          <img
            src={homeStock2mobile}
            alt="Happy children smiling"
            className={styles.image2mobile}
          ></img>
        </Box>

        <Grid
          container
          alignItems="center"
          mt={2}
          justifyContent={{ xs: "center", md: "space-evenly" }}
          spacing={3}
          id="humanitarian-collective"
          height={{ md: "750px" }}
          className={styles.bottomDiv}
        >
          <Grid
            container
            item
            xs={10}
            sm={8}
            justifyContent="center"
            display={{ xs: "block", md: "none" }}
            mt={2}
          >
            <Stack spacing={2} alignItems="center" textAlign="center">
              <ArrowDownwardIcon
                style={{ fontSize: "30px" }}
                onClick={() => handleScrollDownToBottom()}
              ></ArrowDownwardIcon>

              <Typography variant="h6" fontWeight={400}>
                Hope, Healing & Love
              </Typography>

              <Typography variant="body2" fontWeight={400}>
                Join great hearts and mind to impact a world in need - in an
                unprecedented way.
              </Typography>

              <Link to="/explore" className={styles.link}>
                <Button color="primary" variant="contained">
                  Search Projects
                </Button>
              </Link>
            </Stack>
          </Grid>

          <Grid item xs={10} md={4}>
            <Typography variant="h3" textAlign="center" fontWeight="100">
              A Humanitarian Collective
            </Typography>
          </Grid>
          <Grid item width={{ xs: "300px", md: "500px" }} mb={2}>
            <Box className={styles.blueBox}>
              <div className={styles.blueBoxBkg}></div>
              <Stack
                spacing={{ xs: 2, md: 4 }}
                className={styles.blueBoxContent}
                justifyContent="center"
                alignItems="center"
                p={{ xs: 2, md: 8 }}
              >
                <Typography fontSize="20px" lineHeight="20px">
                  Clean Water, Food, Medicine, Conflict Resolution
                </Typography>

                <div className={styles.blueBoxContents}>
                  <div className={styles.blueBoxContentWrapper}>
                    <img src={RightArrow} alt="" />
                    <Typography>
                      We research and vet projects and humanitarian
                      organizations
                    </Typography>
                  </div>
                  <div className={styles.blueBoxContentWrapper}>
                    <img src={RightArrow} alt="" />
                    <Typography>
                      Then partner with impactful, highly integrity
                      organizations
                    </Typography>
                  </div>
                  <div className={styles.blueBoxContentWrapper}>
                    <img src={RightArrow} alt="" />
                    <Typography>
                      And connect these partners with vetted projects and
                      indigenous project contacts
                    </Typography>
                  </div>
                </div>
                {!isAuthenticated && (
                  <div className={styles.blueBoxAction}>
                    <Link to="/join" className={styles.link}>
                      <Button color="primary" variant="contained">
                        Become a Partner
                      </Button>
                    </Link>
                  </div>
                )}
              </Stack>
            </Box>
          </Grid>
        </Grid>
      </div>
    </motion.div>
  );
}
